<template>
  <v-container>
    <v-row id="career">
      <v-col cols="12">
        <SectionTitle :title="label('title')" required/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <FormItem :name="label('currentJob')">
          <JobSelectField
              :value="currentJob"
              :name="label('currentJob')"
              @input="onInputCurrentJob"
          />
        </FormItem>
      </v-col>
    </v-row>
    <CareerHistoryList
                :value="this.value"
                :no-career="this.noCareer"
                edit
                @inputNoCareer="onInputNoCareer"
    />
  </v-container>
</template>

<script>
  import CareerHistoryList from "../molecules/CareerHistoryList";
  import SectionTitle from "../atoms/SectionTitle";
  import ComponentMixin from "../ComponentMixin";
  import {mapGetters} from "vuex";
  import FormItem from "@/components/molecules/FormItem";
  import JobSelectField from "@/components/organisms/JobSelectField";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "CareerHistory",
    props: {
      "value": {
        type: Array,
        default: () => ([])
      },
      currentJob: {
        type: Number
      },
      noCareer: {
        type: Boolean,
        default: false
      },
    },
    data: function() {
      return {
        CareerHistory: {
          company: null,
          position: null,
          isCurrentJob: null,
          isPartTime: null,
          startDate: null,
          endDate: null,
          jobDetail: null
        }
      };
    },
    computed: {
      ...mapGetters("system", ["consts"]),
    },
    methods: {
      onInputNoCareer (value) {
        this.$emit("inputNoCareer", value);
      },
      onInputCurrentJob (value) {
        this.$emit("inputCurrentJob", value)
      },
      submit () {
      }
    },
    components: {
      JobSelectField,
      FormItem,
      CareerHistoryList,
      SectionTitle,
    }
  }
</script>

<style scoped>

</style>
